document.querySelectorAll('.textarea-with-counter').forEach((textarea) => {
  const parentElement = textarea.closest('.mod-input');
  textarea.addEventListener('input', (input) => {
    const characterCountElement = parentElement.querySelector('.mod-input__curr-character');
    characterCountElement.textContent = `${input.target.value.length}`;
  });
});

// *******************************************************************************
// Letters and numbers validation
// *******************************************************************************
const onlyLettersInputs = document.querySelectorAll('[data-letters-only]');

onlyLettersInputs.forEach((input) => {
  input.addEventListener('input', (event) => {
    const inputValue = event.target.value;
    event.target.value = inputValue.replace(/[^a-zA-ZčČšŠžŽđĐćĆ\s]/g, '');
  });
});

const numbersFields1 = document.querySelectorAll('[data-num]');
const numbersFields2 = document.querySelectorAll('input[type="number"]');
const numbersFields = [...numbersFields1, ...numbersFields2];

numbersFields.forEach((input) => {
  input.addEventListener('input', (event) => {
    const inputValue = event.target.value;
    event.target.value = inputValue.replace(/(?!^\+)\D/g, '');
  });
});
